<template>
  <v-form ref="form" v-model="isFormValid" @submit.prevent>
    <admin-input-row
      class="py-3"
      v-for="input in inputs"
      :disabled="disabled || input.disabled"
      v-bind="input"
      :key="input.valueSubproperty + input.name"
      ref="inputs"
      v-on="$listeners"
      :class="{ 'superadmin-row': input.isSuperadmin && !isFirst(input) }"
    >
      <template v-for="(value, key) in $scopedSlots" #[key]="scope">
        <slot :name="key" v-bind="scope" />
      </template>
    </admin-input-row>
  </v-form>
</template>

<script>
import AdminInputRow from '@/components/AdminInputRow';

export default {
  name: 'AdminForm',
  components: {
    AdminInputRow,
  },
  props: {
    inputs: {
      type: Array,
      default: () => [],
    },
    // isFormValid: {
    //   type: Boolean,
    //   default: true,
    // },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isFormValid: false,
  }),
  computed: {
    // computedIsFormValid: {
    //   get() {
    //     return this.isFormValid;
    //   },
    //   set(nV) {
    //     this.$emit('update:isFormValid', nV);
    //   },
    // },
  },
  watch: {
    isFormValid(nV) {
      this.$emit('update:isFormValid', nV);
    },
  },
  methods: {
    isFirst(input) {
      return this.inputs.indexOf(input) === 0;
    },
    save() {
      this.$refs.inputs
        .filter(input => !input.isCustom)
        .forEach(input => {
          input.save();
        });
    },
  },
  mounted() {
    this.$refs?.form.validate();
  },
};
</script>

<style lang="scss" scoped>
.superadmin-row {
  @include border(top, 1px);
  margin-top: 15px;
  padding-top: 20px !important;
}
</style>
